export const CREATE_USER_FIELDS = [
  {
    name: "username",
    type: "string",
    placeholder: "Enter your username",
    label: "user-51"
  },
  {
    name: "fullName",
    type: "text",
    placeholder: "Enter your fullname",
    label: "user-52"
  },
  {
    name: "password",
    type: "password",
    placeholder: "Enter your password",
    label: "user-53"
  }
  // {
  //   name: "email",
  //   type: "email",
  //   placeholder: "Enter your email address",
  //   label: "Email Address *"
  // }
  // {
  //   name: "roles",
  //   type: "select",
  //   placeholder: "Select",
  //   label: "User Group",
  //   mode: "multiple",
  // },
];

export const CREATE_USER_GROUP_FIELDS = [
  {
    name: "name",
    type: "string",
    placeholder: "Enter the group name",
    label: "Group Name*"
  }
];
